export default function DummySkeleton() {
  return (
    <div className="w-screen h-screen flex bg-card overflow-hidden select-none">
      {/* Sidebar */}
      {/* <aside className="w-20 bg-muted border-r border-border flex flex-col items-center py-6 gap-4">
        {[...Array(6)].map((_, i) => (
          <div
            key={i}
            className="h-8 w-8 rounded-md bg-muted-foreground/30 animate-pulse"
          />
        ))}
      </aside> */}

      {/* Main Section */}
      <div className="flex-1 flex flex-col">
        <header className="h-14 bg-muted-foreground/20 border-b border-border flex items-center justify-center">
          <div className="h-4 w-48 bg-muted-foreground/30 rounded animate-pulse"></div>
        </header>
        <div className="flex-1 flex items-center justify-center bg-muted/50 relative">
          <div className="flex flex-col items-center gap-3">
            <div className="h-10 w-10 rounded-full border-4 border-border border-t-gray-500 animate-spin"></div>
            <p className="text-foreground/70 text-sm tracking-wide animate-pulse">
              Loading…
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
